/**
 * PostConverter 工具函数
 * 用于 CloudPost 数组的排序操作
 */

import type { CloudPost } from '../types';

/**
 * 对 CloudPost 数组进行排序（置顶优先，然后按时间降序）
 * @param posts CloudPost 数组
 * @returns 排序后的 CloudPost 数组
 */
export const sortCloudPosts = (posts: CloudPost[]): CloudPost[] => {
  return [...posts].sort((a, b) => {
    if (a.isPinned !== b.isPinned) return b.isPinned ? 1 : -1;
    const timeA = new Date(a.createdAt || 0).getTime();
    const timeB = new Date(b.createdAt || 0).getTime();
    return timeB - timeA;
  });
};
